var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import "./campaign.css";
import { useEffect, useState } from "react";
import { api } from "../../services/http.service";
import { env } from "../../constants/global.constants";
import { isMobile } from "../../App";
import _ from "lodash";
import { auth } from "../../store/auth.store";
import { modalServiceSubject } from "../../services/modal.service";
import { useNavigate, useLocation } from "react-router";
import { useSearchParams } from "react-router-dom";
import paths from "../../paths";
import { copyMemberNumber } from "../../services/misc.functions";
export function Campaigns() {
    var navigate = useNavigate();
    var location = useLocation();
    var searchParams = useSearchParams()[0];
    var _a = useState([]), dataList = _a[0], setDataList = _a[1];
    var _b = useState(0), selectedTab = _b[0], setSelectedTab = _b[1];
    var joinCampaign = function (id) {
        if (auth.member) {
            api
                .start("post", env.accounting_api + "/misc/api/create-member-campaign/", { campaign_id: id }, true)
                .then(function (res) {
                if (res && res.status) {
                    if (id === 8 || id === 107 || id === 206) {
                        // Arkadaşını Getir Kampanyası
                        modalServiceSubject.next({
                            case: "info",
                            title: "Başarılı!",
                            content: "<p class=\"text-center\">Kampanya'ya kat\u0131l\u0131m\u0131n\u0131z ger\u00E7ekle\u015Fmi\u015Ftir.</p><p class=\"text-center\">".concat(env.web_link, "/uye-ol?referer=").concat(auth.member.id.toString(16).toUpperCase(), "</p>"),
                            confirm: {
                                sure: {
                                    label: "Referans Linki Kopyala",
                                    action: function () {
                                        copyMemberNumber("".concat(env.web_link, "/uye-ol?referer=").concat(auth.member.id.toString(16).toUpperCase()), "Referans Linkiniz kopyalandı!");
                                    },
                                },
                            },
                        });
                    }
                    else {
                        modalServiceSubject.next({
                            case: "success",
                            title: "Başarılı!",
                            content: "<p class=\"text-center\">Kampanya'ya kat\u0131l\u0131m\u0131n\u0131z ger\u00E7ekle\u015Fmi\u015Ftir.</p>",
                            confirm: {
                                cancel: {
                                    label: "Tamam",
                                    class: "btn-success w-100",
                                },
                            },
                        });
                    }
                    getCampaigns();
                }
                else {
                    modalServiceSubject.next({
                        case: "danger",
                        title: "İşlem Başarısız!",
                        content: "<p class=\"text-center\">".concat(res.message ? res.message : "", "</p>"),
                        confirm: {
                            cancel: {
                                class: "btn-danger",
                                label: "Tamam",
                            },
                        },
                    });
                }
            });
        }
        else {
            modalServiceSubject.next({
                class: "success",
                title: "Üye Girişi",
                content: "<p>Kampanya'ya kat\u0131lmak i\u00E7in \u00F6nce oturum a\u00E7man\u0131z gerekli. \u00DCye de\u011Filseniz hemen \u00FCye olabilir yada giri\u015F yaparak kampanya'ya kat\u0131labilirsiniz.</p>",
                confirm: {
                    sure: {
                        label: "Giriş Yap",
                        class: "btn btn-success",
                        action: function () {
                            navigate(paths.login.url);
                        },
                    },
                    cancel: {
                        label: "Üye Ol",
                        class: "btn btn-info",
                        action: function () {
                            navigate(paths.register.url);
                        },
                    },
                },
            });
        }
    };
    var getCampaigns = function () {
        if (auth.member) {
            api
                .start("get", env.accounting_api + "/misc/api/list_campaign_control/", null, true)
                .then(function (res) {
                // console.log(res)
                if (res && res.status) {
                    setDataList(_.orderBy(res.data, ["is_valid", "create_date"], ["desc"]));
                }
            });
        }
        else {
            api
                .start("get", env.accounting_api + "/misc/api/list-campaign/", null, true)
                .then(function (res) {
                // console.log(res)
                if (res && res.status) {
                    // remove the campaign with id 131. papara 150 kampanysı sorgudan ayıklanır.
                    setDataList(_.orderBy(res.data, ["is_valid", "create_date"], ["desc"]).filter(function (el) { return el.id !== 131; }));
                }
            });
        }
    };
    useEffect(function () {
        // URL'den tab parametresini oku
        var tabParam = searchParams.get('tab');
        if (tabParam !== null) {
            setSelectedTab(parseInt(tabParam));
        }
        else {
            setSelectedTab(0); // Reset tab when page loads
        }
        getCampaigns();
    }, [location.pathname, searchParams]);
    var campaignTabs = [
        {
            key: "current",
            label: "Güncel Kampanyalarımız",
            isActive: selectedTab === 0,
            onSelect: function () { return setSelectedTab(0); },
        },
        {
            key: "past",
            label: "Geçmiş Kampanyalarımız",
            isActive: selectedTab === 1,
            onSelect: function () { return setSelectedTab(1); },
        },
    ];
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "campaigns mt-3" }, { children: [isMobile && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "row mt-3 raffle-page-title-bar" }, { children: _jsx("h1", __assign({ className: "fs-5 fw-bold mx-2 text-uppercase" }, { children: "Kampanyalar" })) })), _jsx("div", __assign({ className: "row inner-page-top-tabs mb-1" }, { children: _jsx("div", __assign({ className: "col-12" }, { children: _jsx("div", __assign({ className: "custom-tabs custom-tabs-mobile" }, { children: campaignTabs.map(function (tab) { return (_jsx("div", __assign({ className: "custom-tab-item ".concat(tab.isActive ? "active" : ""), role: "button", tabIndex: 0, onClick: tab.onSelect, onKeyDown: function (event) {
                                            if (event.key === "Enter" || event.key === " ") {
                                                event.preventDefault();
                                                tab.onSelect();
                                            }
                                        } }, { children: _jsx("h2", __assign({ className: "fs-6 fw-bold mb-0" }, { children: tab.label })) }), tab.key)); }) })) })) }))] })), !isMobile && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "row mt-3 raffle-page-title-bar" }, { children: _jsx("h1", __assign({ className: "fs-5 fw-bold mx-2 text-uppercase" }, { children: "Kampanyalar" })) })), _jsx("div", __assign({ className: "row" }, { children: _jsx("div", __assign({ className: "mb-0 mt-1" }, { children: _jsx("div", __assign({ className: "custom-tabs" }, { children: campaignTabs.map(function (tab) { return (_jsx("div", __assign({ className: "custom-tab-item ".concat(tab.isActive ? "active" : ""), role: "button", tabIndex: 0, onClick: tab.onSelect, onKeyDown: function (event) {
                                            if (event.key === "Enter" || event.key === " ") {
                                                event.preventDefault();
                                                tab.onSelect();
                                            }
                                        } }, { children: _jsx("h2", __assign({ className: "fs-6 fw-bold mb-0" }, { children: tab.label })) }), tab.key)); }) })) })) }))] })), _jsx("div", __assign({ className: "row d-flex align-items-stretch campaigns-list-row" }, { children: dataList.map(function (el, key) {
                        if (selectedTab == 1 && !el.is_valid) {
                            return (_jsx("div", __assign({ className: "col-4 col-mobile-12 campaign-item", onClick: function () {
                                    navigate("/kampanyalar/".concat(el.id));
                                } }, { children: _jsxs("div", __assign({ className: "campaign-widget" }, { children: [_jsx("img", { src: env.cdn_host + el.photo, alt: "" }), _jsxs("div", __assign({ className: "body" }, { children: [_jsx("h2", __assign({ className: "title" }, { children: el.name })), _jsx("span", __assign({ className: "sub-title" }, { children: el.title_abbreviated }))] })), _jsxs("div", __assign({ className: "footer" }, { children: [_jsx("button", __assign({ className: "btn btn-primary", onClick: function (e) {
                                                        e.stopPropagation();
                                                        navigate("/kampanyalar/".concat(el.id));
                                                    } }, { children: "Kampanya Detaylar\u0131" })), _jsx("button", __assign({ className: "btn btn-expired" }, { children: "KAMPANYA S\u00DCRES\u0130 DOLDU" }))] }))] })) }), key));
                        }
                        else if (selectedTab == 0 && el.is_valid) {
                            return (_jsx("div", __assign({ className: "col-4 col-mobile-12 campaign-item", onClick: function () {
                                    navigate("/kampanyalar/".concat(el.id));
                                } }, { children: _jsxs("div", __assign({ className: "campaign-widget" }, { children: [!el.is_valid ? (_jsx("div", __assign({ className: "ribbon ribbon-old" }, { children: _jsx("span", { children: "Ge\u00E7mi\u015F" }) }))) : null, _jsx("img", { src: env.cdn_host + el.photo, alt: "" }), _jsxs("div", __assign({ className: "body" }, { children: [_jsx("h2", __assign({ className: "title" }, { children: el.name })), _jsx("span", __assign({ className: "sub-title" }, { children: el.title_abbreviated }))] })), _jsxs("div", __assign({ className: "footer" }, { children: [_jsx("button", __assign({ className: "btn btn-primary", onClick: function (e) {
                                                        e.stopPropagation();
                                                        navigate("/kampanyalar/".concat(el.id));
                                                    } }, { children: "Kampanya Detaylar\u0131" })), auth.member && (_jsx("button", __assign({ className: "btn btn-secondary", onClick: function (e) {
                                                        e.stopPropagation();
                                                        joinCampaign(el.id);
                                                    } }, { children: "Kampanyaya Kat\u0131l" })))] }))] })) }), key));
                        }
                    }) }))] })) }));
}
